import React from 'react';
import {
  DetailCardContainer,
  DetailCardHeader,
  DetailCardText
} from './styles';

import { TooltipDetail } from '../TooltipDetail';
import DeliveryStatusColumn from '../../OrdersTable/DeliveryStatusColumn';

interface Props {
  canShow?: boolean;
  title: string;
  subtitle?: string;
  withoutSubtitle?: boolean;
  withTag?: boolean;
  countOverdue?: boolean;
  titleTooltip?: string;
  placement?: 'bottomLeft' | 'topLeft';
  futureDeliveriesTable?: string;
  children?: React.ReactNode;
}

export const DetailCard = ({
  countOverdue,
  withTag,
  subtitle,
  title,
  placement,
  titleTooltip,
  canShow = true,
  futureDeliveriesTable,
  children,
  withoutSubtitle
}: Props) => {
  const renderSubtitle = () => {
    if (withoutSubtitle) {
      return null;
    }

    if (withTag) {
      return (
        <DeliveryStatusColumn
          countOverdue={countOverdue}
          data={futureDeliveriesTable}
        />
      );
    }

    if (!subtitle) {
      return 'Indisponível';
    }

    return subtitle;
  };

  return (
    <DetailCardContainer>
      {!canShow ? null : (
        <>
          <DetailCardHeader>
            <DetailCardText bold>{title}</DetailCardText>
            <TooltipDetail
              {...{ titleTooltip: titleTooltip, placement: placement }}
            />
          </DetailCardHeader>
          {children}
          <DetailCardText>{renderSubtitle()}</DetailCardText>
        </>
      )}
    </DetailCardContainer>
  );
};
